import { jsx as n, jsxs as f } from "react/jsx-runtime";
import { ListBoxSelect as u, Tooltip as d } from "@systemeio/ui";
import { useEditorState as h } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as T } from "react";
import { ToolbarSelectButton as p } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as b, getToolbarIconClassName as g } from "../../constants/default-styles.mjs";
import { TextLevelEnum as v } from "./text-level-enum.mjs";
import x from "../../icons/heading-icon.mjs";
import { getCurrentTextLevelValue as L, getTextLevelValues as c } from "./utils/text-level.mjs";
import { useTranslation as I } from "../../i18n.mjs";
import { isImageSelected as C } from "../image-extension/utils/is-image-selected.mjs";
const z = (s) => {
  var m;
  const { t: a } = I(), l = h({
    editor: s,
    selector: ({ editor: e }) => ({
      isEditable: (e == null ? void 0 : e.options.editable) ?? !1,
      textLevel: L(e),
      isImageSelected: C(e)
    })
  }), r = l == null ? void 0 : l.textLevel, i = (m = c(a).find((e) => e.id === r)) == null ? void 0 : m.caption, t = !(l != null && l.isEditable) || !!(l != null && l.isImageSelected);
  return T(() => {
    const e = (o) => {
      if (!s) return null;
      if (o === v.Default)
        return s.chain().focus().setParagraph().run();
      s.chain().focus().toggleHeading({ level: o }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ n(
        u,
        {
          disabled: t,
          value: r,
          onChange: e,
          data: c(a),
          children: (o) => /* @__PURE__ */ n(
            d,
            {
              disabled: t,
              label: a("text_level.title"),
              anchor: "left",
              ...b,
              children: /* @__PURE__ */ f(p, { className: "flex gap-1", disabled: t, open: o, children: [
                /* @__PURE__ */ n(x, { className: g(t) }),
                i
              ] })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ n(
        u,
        {
          optionsClassName: "z-40",
          disabled: t,
          value: r,
          onChange: e,
          data: c(a),
          children: (o) => /* @__PURE__ */ n(
            d,
            {
              disabled: t,
              label: a("text_level.title"),
              anchor: "left",
              ...b,
              children: /* @__PURE__ */ f(p, { className: "flex gap-1", disabled: t, open: o, children: [
                /* @__PURE__ */ n(x, { className: g(t) }),
                i
              ] })
            }
          )
        }
      )
    };
  }, [i, r, s, t, a]);
};
export {
  z as useHeadingExtensionToolbar
};
